import Button from "component/ui/Button";
import Input from "component/ui/Input";
import SelectField from "component/ui/SelectField";
import React, { useRef, useState } from "react";
import {
  categoryOption,
  designationOption,
  roleOption,
  levelOption,
  roles,
} from "../../../helper/constant";
import RadioCardGroup from "component/ui/RadioCardGroup";
import Textarea from "component/ui/Textarea";
import { useDispatch, useSelector } from "react-redux";
import { IoCloseCircleSharp, IoCloudUploadOutline } from "react-icons/io5";
import moment from "moment";
import { uploadImages } from "store/slice/auth";

const KeyMembers = ({
  handleSubmit,
  profileData,
  setProfileData,
  keyMember_initital_state,
  achievement_initital_state,
}) => {
  const [designation, setdesignation] = useState();
  const [status, setStatus] = useState("");
  const [level, setLevel] = useState("");
  const [noExpiry, setNoExpiry] = useState(false);
  const { configData } = useSelector((state) => state.auth);
  const [imageLoader, setImageLoader] = useState(false);
  const proofRef = useRef(null);
  const dispatch = useDispatch();
  const options = [
    { label: "Active", value: "Active" },
    { label: "Removed", value: "Removed" },
  ];

  // handle upload proof images
  const handleUploadFile = async (file, index) => {
    if (!file) return;
    setImageLoader(true);
    const formData = new FormData();
    formData.append("file", file);
    const data = await dispatch(uploadImages(formData, "proofDocument"));
    if (data?.length > 0) {
      let temp = { ...profileData };
      temp.achievementsAndCertifications[index].proof = data[0]?.fileName;
      temp.achievementsAndCertifications[index].proofPath = data[0]?.path;
      setProfileData(temp);
    }
    setImageLoader(false);
  };

  return (
    <div>
      {/* keyMember */}
      {profileData?.keyMember?.length > 0 &&
        profileData?.keyMember?.map((key, index) => (
          <div className="border-2  rounded-lg md:p-4 p-2 relative grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            {index != 0 && (
              <div className="absolute top-1 right-1">
                <IoCloseCircleSharp
                  onClick={(value) => {
                    let temp = { ...profileData };
                    temp.keyMember = temp.keyMember.filter(
                      (_, i) => i !== index
                    );
                    setProfileData(temp);
                  }}
                  className="h-6 w-6 cursor-pointer"
                  color="red"
                />
              </div>
            )}
            <Input
              value={key?.name}
              onChange={(value) => {
                let temp = { ...profileData };
                temp.keyMember[index].name = value;
                setProfileData(temp);
              }}
              label="Name"
              placeholder="Enter name"
            />

            <Input
              label="Email"
              value={key?.email}
              onChange={(value) => {
                let temp = { ...profileData };
                temp.keyMember[index].email = value;
                setProfileData(temp);
              }}
              placeholder="Enter email"
              type="email"
            />

            <SelectField
              label="Designation (display)"
              id="gender"
              value={key?.designation || ""}
              onChange={(value) => {
                let temp = { ...profileData };
                temp.keyMember[index].designation = value;
                setProfileData(temp);
              }}
              options={designationOption}
              placeholder="Select designation"
            />

            <SelectField
              isKeyMemberRole
              label="Role / Permissions (system)"
              placeholder="Select role"
              options={configData?.keyMembersRoles}
              value={key?.roleId}
              onChange={(value) => {
                let obj = configData?.keyMembersRoles?.find(
                  (item) => item?.id == value
                );
                let temp = { ...profileData };
                temp.keyMember[index].roleId = obj?.id;
                temp.keyMember[index].roleName = obj?.roleName;
                setProfileData(temp);
              }}
            />

            {/* Status */}
            <RadioCardGroup
              label="Status"
              options={options}
              value={key?.status || ""}
              onChange={(value) => {
                let temp = { ...profileData };
                temp.keyMember[index].status = value;
                setProfileData(temp);
              }}
            />
          </div>
        ))}
      {profileData?.keyMember?.length < 5 && (
        <p
          onClick={() => {
            let temp = { ...profileData };
            temp?.keyMember?.push(keyMember_initital_state);
            setProfileData(temp);
          }}
          className="flex mt-3 font-semibold  justify-end w-full text-md text-[#2bace2] cursor-pointer"
        >
          + Add More
        </p>
      )}

      {/* Associated Organizations */}

      <h2 className="md:text-xl text-lg md:font-bold font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
        <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
        🏦 {profileData?.userType == roles?.VENUE ? 'Associated & Hosted Organisations' : 'Organisations Associated'}
      </h2>
      <div className="border-2 rounded-lg md:p-4 p-2 grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          isRequired
          value={profileData?.clubOrganization}
          onChange={(value) => {
            setProfileData((profile) => ({
              ...profile,
              clubOrganization: value,
            }));
          }}
          label={profileData?.userType == roles?.VENUE ? "Primary Club / Organisation Associated With" : 'Primary Organisations'}
          placeholder={profileData?.userType == roles?.VENUE ? "Enter primary club / organisation" : 'Primary Organisation you are part of'}
          className=""
        />

        <Input
          value={profileData?.role}
          onChange={(value) => {
            setProfileData((profile) => ({
              ...profile,
              role: value,
            }));
          }}
          label="Role (if any)"
          placeholder="Enter role"
          className=""
        />
      </div>
      {/* <p
        onClick={() => {
          let temp = { ...profileData };
          // temp?.keyMember?.push(keyMember_initital_state);
          setProfileData(temp);
        }}
        className="font-semibold mt-2 flex justify-end w-full text-md text-[#2bace2] cursor-pointer"
      >
        + Add More
      </p> */}
      <Input
        isRequired
        label="Hosted Clubs / Academies"
        placeholder="Enter hosted clubs / academies"
        className="mb-6 mt-5"
      />

      <h2 className="md:text-xl text-lg md:font-bold font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
        <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
        🏆 Achievements / Certifications
      </h2>
      {profileData?.achievementsAndCertifications?.map((achievement, index) => (
        <div className="border-2 relative rounded-lg md:p-4 p-2 mt-3 grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Row 1: Designation & Title */}
          {index != 0 && (
            <div className="absolute top-1 right-1">
              <IoCloseCircleSharp
                onClick={(value) => {
                  let temp = { ...profileData };
                  temp.achievementsAndCertifications =
                    temp.achievementsAndCertifications.filter(
                      (_, i) => i !== index
                    );
                  setProfileData(temp);
                }}
                className="h-6 w-6 cursor-pointer"
                color="red"
              />
            </div>
          )}
          <SelectField
            label="Category Selector"
            id="designation-select"
            value={achievement?.categorySelector}
            onChange={(value) => {
              let temp = { ...profileData };
              temp.achievementsAndCertifications[index].categorySelector =
                value;
              setProfileData(temp);
            }}
            options={categoryOption}
            placeholder="Select Category"
          />

          <Input
            value={achievement?.title}
            onChange={(value) => {
              let temp = { ...profileData };
              temp.achievementsAndCertifications[index].title = value;
              setProfileData(temp);
            }}
            label="Title"
            placeholder="Enter title"
          />

          {/* Row 2: Issuing Org & Level */}
          <Input
            onChange={(value) => {
              let temp = { ...profileData };
              temp.achievementsAndCertifications[index].issuingOrganization =
                value;
              setProfileData(temp);
            }}
            value={achievement?.issuingOrganization}
            label="Issuing Organization"
            placeholder="Enter issuing organization"
          />

          <SelectField
            label="Level"
            id="level-select"
            onChange={(value) => {
              let temp = { ...profileData };
              temp.achievementsAndCertifications[index].level = value;
              setProfileData(temp);
            }}
            value={achievement?.level}
            options={levelOption}
            placeholder="Select level"
          />

          {/* Row 3: Date & Validity */}
          <Input
            onChange={(value) => {
              let temp = { ...profileData };
              temp.achievementsAndCertifications[index].date = moment(
                value,
                "YYYY-MM-DD"
              ).valueOf();
              setProfileData(temp);
            }}
            value={moment(achievement?.date).format("YYYY-MM-DD")}
            label="Date"
            type="date"
          />

          <div className="flex flex-col justify-end">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Validity
            </label>
            <div className="flex md:flex-row flex-col md:items-center gap-4 md:h-[44px]">
              {" "}
              <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-600">
                <input
                  type="checkbox"
                  className="w-4 h-4 rounded border-gray-300 text-[#2bace2] focus:ring-[#2bace2]"
                  checked={achievement?.expiry}
                  onChange={(e) => {
                    let temp = { ...profileData };
                    temp.achievementsAndCertifications[index].expiry =
                      e.target.checked;
                    setProfileData(temp);
                  }}
                />
                No Expiry
              </label>
              <div className="md:flex-1 w-full">
                {!achievement?.expiry && (
                  <Input
                    onChange={(value) => {
                      let temp = { ...profileData };
                      temp.achievementsAndCertifications[index].validity =
                        moment(value, "YYYY-MM-DD").valueOf();
                      setProfileData(temp);
                    }}
                    value={moment(achievement?.validity).format("YYYY-MM-DD")}
                    type="date"
                    className="!mt-0"
                  />
                )}
              </div>
            </div>
          </div>

          {/* Row 4: Description (Full Width) */}
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Description
            </label>
            <Textarea
              value={achievement?.description}
              onChange={(e) => {
                let temp = { ...profileData };
                temp.achievementsAndCertifications[index].description =
                  e.target.value;
                setProfileData(temp);
              }}
              placeholder="Briefly describe this achievement or certification..."
              rows="4"
            />
          </div>

          <div className="space-y-2 md:col-span-2">
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Proof Upload <span className="text-red-500">*</span>
            </label>
            <input
              ref={proofRef}
              onChange={(e) => {
                handleUploadFile(e.target.files[0], index);
              }}
              style={{ display: "none" }}
              type="file"
              accept="image/*"
            />
            <div
              style={{
                backgroundImage: achievement?.proofPath
                  ? `url("${achievement?.proofPath}")`
                  : "",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                border: achievement?.proofPath
                  ? "1px solid gray"
                  : "2px dashed #2bace2",
              }}
              onClick={() => {
                if (!achievement?.proofPath || imageLoader) {
                  proofRef.current?.click();
                }
              }}
              className="relative cursor-pointer border-2 w-28 h-28 flex justify-center items-center rounded-lg group"
            >
              {achievement?.proofPath && (
                <div className="absolute top-0 right-0">
                  <IoCloseCircleSharp
                    onClick={(value) => {
                      value.stopPropagation();
                      let temp = { ...profileData };
                      temp.achievementsAndCertifications[index].proof = "";
                      temp.achievementsAndCertifications[index].proofPath = "";
                      setProfileData(temp);
                    }}
                    className="h-6 w-6 cursor-pointer"
                    color="red"
                  />
                </div>
              )}
              {imageLoader && (
                <div className="h-10 w-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              )}
              {!achievement?.proofPath && !imageLoader && (
                <IoCloudUploadOutline className="h-8 w-8" color="#2bace2" />
              )}
            </div>
          </div>
        </div>
      ))}
      {profileData?.achievementsAndCertifications?.length < 15 && (
        <p
          onClick={() => {
            let temp = { ...profileData };
            temp?.achievementsAndCertifications?.push(
              achievement_initital_state
            );
            setProfileData(temp);
          }}
          className="font-semibold mt-2 flex justify-end w-full text-md text-[#2bace2] cursor-pointer"
        >
          + Add More
        </p>
      )}
      {/* Submit Button */}
      <Button
        color="primary"
        onClick={handleSubmit}
        className="md:w-1/2 mt-8 w-full mx-auto flex justify-center "
      >
        Update Profile
      </Button>
    </div>
  );
};

export default KeyMembers;
